import Component from '../abstracts/Component';
import NewsletterLogic from '../logics/NewsletterLogic';
import TrackingComponent from '../components/TrackingComponent';

export default class FooterNewsletterComponent extends Component {
  get SELECTORS() {
    return {
      newsletterBox: '.c-newsletter-footer ',
      form: '#newsletterForm-footer',
      emailInput: '#footerNewsletterInput',
      submitButton: '[data-submit-button]',
      privacyCheckbox: '[data-privacy-checkbox]',
      formWrapper: '[data-js-form-wrapper]',
      formSuccess: '[data-js-form-success]',
      newsletterError: '.newsletter-error-msg',
      newsletterAlready: '.newsletter-already-msg'
    };
  }

  get CLASSES() {
    return {
      success: 'success',
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.submitButton = this.$component.querySelector(this.SELECTORS.submitButton);
    this.privacyCheckbox = this.$component.querySelector(this.SELECTORS.privacyCheckbox);
    this.newsletterBox = this.$component.querySelector(this.SELECTORS.newsletterBox);
    this.form = this.$component.querySelector(this.SELECTORS.form);
    this.emailInput = this.$component.querySelector(this.SELECTORS.emailInput);
    this.formWrapper = this.$component.querySelector(this.SELECTORS.formWrapper);
    this.formSuccess = this.$component.querySelector(this.SELECTORS.formSuccess);
    this.newsletterError = this.$component.querySelector(this.SELECTORS.newsletterError);
    this.newsletterAlready = this.$component.querySelector(this.SELECTORS.newsletterAlready);
    this.trackingComponent = new TrackingComponent();
  }

  enableSubmitBtn() {
    if (this.privacyCheckbox && this.submitButton) {
      this.privacyCheckbox.addEventListener('change', (event) => {
        this.submitButton.disabled = !(event.currentTarget.checked);
      });
    }
  }

  handleFormSubmit() {
    if(this.form) {
      const url = this.form.getAttribute('action');
      this.form.addEventListener("submit", (event) => {
        const form = new FormData(event.target);
        event.preventDefault();
        const response = this.NewsletterLogic.subscribeNewsletter(url, form);
        response.then(response => {
          if(response.ok) {
            this.formWrapper.classList.add('hidden');
            this.formSuccess.classList.remove('hidden');
            this.newsletterError.classList.add('hidden');
            this.newsletterAlready.classList.add('hidden');
            this.trackingComponent.trackAction('newsletterSubscribe', this.submitButton.dataset);
          } else {
            if (response.status === 400) {
              this.newsletterError.classList.remove('hidden');
            }
            if (response.status === 403) {
              this.newsletterAlready.classList.remove('hidden');
            }
            this.formWrapper.classList.remove('hidden');
            this.formSuccess.classList.add('hidden');
          }
        })
      });
    }
  }

  handleInputChange() {
    if(this.emailInput) {
      this.emailInput.addEventListener("input", event => {
        this.newsletterError?.classList.add('hidden');
        this.newsletterAlready?.classList.add('hidden');
      });
    }
  }

  bindEvents() {
    this.enableSubmitBtn();
    this.handleFormSubmit();
    this.handleInputChange();
  }

  render() {
    super.render();
    this.NewsletterLogic = new NewsletterLogic();
    this.bindEvents();
  }
}
